import { Keys } from 'excalibur';
import { button } from './button';
import { KeyboardLike } from './KeyboardLike';
import { stick } from './stick';

// Player 1 (left keyboard) mapping: WASD + Space, with common extras

export const leftKeyboard = (keyboard: KeyboardLike) => {
    return {
        leftStick: stick(keyboard, {
            left: Keys.A,
            right: Keys.D,
            up: Keys.W,
            down: Keys.S,
            press: Keys.Space,
        }),
        rightStick: stick(keyboard, {
            left: Keys.J,
            right: Keys.L,
            up: Keys.I,
            down: Keys.K,
            press: Keys.U,
        }),
        aOrCross: button(keyboard, Keys.F),
        bOrCircle: button(keyboard, Keys.G),
        xOrSquare: button(keyboard, Keys.R),
        yOrTriangle: button(keyboard, Keys.T),
        leftBumper: button(keyboard, Keys.Q),
        rightBumper: button(keyboard, Keys.E),
        leftTrigger: {
            get holding() {
                return keyboard.isHeld(Keys.Z) ? 1 : 0;
            },
            get pressed() {
                return keyboard.wasPressed(Keys.Z);
            },
        },
        rightTrigger: {
            get holding() {
                return keyboard.isHeld(Keys.C) ? 1 : 0;
            },
            get pressed() {
                return keyboard.wasPressed(Keys.C);
            },
        },
        back: button(keyboard, Keys.Esc),
        start: button(keyboard, Keys.Enter),
        dpadUp: button(keyboard, Keys.Up),
        dpadDown: button(keyboard, Keys.Down),
        dpadLeft: button(keyboard, Keys.Left),
        dpadRight: button(keyboard, Keys.Right),
    };
};
